import { render, staticRenderFns } from "./FraudPreventionMenuView.vue?vue&type=template&id=08092e92&"
import script from "./FraudPreventionMenuView.vue?vue&type=script&lang=js&"
export * from "./FraudPreventionMenuView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports